import React from 'react';
import { Link } from 'react-router-dom';

// Mention markup produced by the backend: @[First Last](user-uuid)
const MENTION_RE = /@\[([^[\]]{1,120})\]\(([0-9a-fA-F-]{36})\)/g;

export const stripMentionTokens = (text) =>
  (text || '').replace(MENTION_RE, (_m, name) => name);

export const FeedPostContent = ({ content, className = '', testId }) => {
  if (!content) return null;
  const parts = [];
  let last = 0;
  let match;
  MENTION_RE.lastIndex = 0;
  while ((match = MENTION_RE.exec(content)) !== null) {
    if (match.index > last) parts.push(content.slice(last, match.index));
    parts.push({ name: match[1], userId: match[2] });
    last = match.index + match[0].length;
  }
  if (last < content.length) parts.push(content.slice(last));

  return (
    <span className={className} data-testid={testId}>
      {parts.map((part, i) =>
        typeof part === 'string' ? (
          <React.Fragment key={i}>{part}</React.Fragment>
        ) : (
          <Link
            key={i}
            to={`/community/member/${part.userId}`}
            className="text-cyan-700 font-semibold hover:underline"
            data-testid={`feed-mention-${part.userId}`}
          >
            @{part.name}
          </Link>
        ),
      )}
    </span>
  );
};

export default FeedPostContent;
